import {autoinject, bindable} from "aurelia-framework";
import {Router} from "aurelia-router";
import {CartService, GiftCard} from "../cart-service";

@autoinject()
export class Page2Amount {

  private giftCard: GiftCard = new GiftCard();

  private nextButtonDisabled = true;
  private showCustomAmountField: boolean = false;

  @bindable
  private customAmount: number = 0;

  constructor(private router: Router, private cartService: CartService) {
    window.scrollTo(0, 0);
  }

  private amountValues: number[] = [20, 25, 30, 35, 40, 50];

  private quantityValues: number[] = this.generateNumerArray(10);

  private generateNumerArray(value: number): number[] {
    let array: number[] = [];

    for (let i = 1; i < value + 1; i++) {
      array.push(i)
    }
    return array

  }

  private next() {

    this.cartService.addGiftCard(this.giftCard);
    this.router.navigate("page3-cart")
  }

  private customValueSelectorClicked() {
    this.showCustomAmountField = true
  }

  private valueSelected(amount: number) {
    this.showCustomAmountField = false;
    this.giftCard.amount = amount;
    this.nextButtonDisabled = false;

    try {
      NY_TRACKER.trackClick({
        value: amount.toString(),
        label: 'page2',
        action: 'amountSelected',
        category: "GiftcardClient"
      })
    } catch (e) {
      console.log("no tracking inizialized");
    }



  }

  private customAmountChanged(amount: number) {
    amount = Math.round(amount);
    if (amount < 20) {
      amount = 20;
      this.customAmount = amount;
    }

    if (amount > 500) {
      amount = 500;
      this.customAmount = 500
    }


    this.giftCard.amount = amount;
    this.nextButtonDisabled = false;
    try {
      NY_TRACKER.trackClick({
        value: amount.toString(),
        label: 'page2',
        action: 'customAmountSelected',
        category: "GiftcardClient"
      })

    } catch (e) {
      console.log("no tracking inizialized");
    }
  }

  private trackChangeQuantity() {
    try {
      NY_TRACKER.trackClick({
        value: this.giftCard.count.toString(),
        label: 'page2',
        action: 'quantitySelected',
        category: "GiftcardClient"
      })

    } catch (e) {
      console.log("no tracking inizialized");
    }
  }


}